import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import { useMemo } from 'react';
import { useEditor } from '../../hooks/useEditor.js';
import { findNode, findAncestorNodes, setNode } from '../../utils/node.js';
import { jsx } from '@emotion/react';

var _excluded = ["children", "props", "parents"];
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function Inspector() {
  var _useEditor = useEditor(),
    state = _useEditor.state,
    setState = _useEditor.setState,
    components = _useEditor.components;
  var document = state.document,
    cursor = state.cursor;
  var node = findNode(document, cursor);
  var parents = findAncestorNodes(document, cursor).map(function (_ref) {
    _ref.children;
      _ref.props;
      _ref.parents;
      var others = _objectWithoutProperties(_ref, _excluded);
    return _objectSpread2(_objectSpread2({}, others), {}, {
      props: {},
      children: []
    });
  });
  var component = node != null ? components[node.type] : null;
  var child = useMemo(function () {
    return component != null && node != null && component.renderInspector != null && component.renderInspector({
      value: {
        key: node.key,
        type: node.type,
        parents: parents,
        props: _objectSpread2(_objectSpread2({}, component === null || component === void 0 ? void 0 : component.defaultProps), node.props),
        children: node.children
      },
      onChange: function onChange(value) {
        setState(function (prevState) {
          return _objectSpread2(_objectSpread2({}, prevState), {}, {
            document: setNode(prevState.document, cursor, value)
          });
        });
      }
    });
  }, [component, node, cursor, setState]);
  if (node == null) {
    return null;
  }
  return jsx(Container, {
    key: node.key
  }, child);
}
var Container = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "emhgmbd0"
} : {
  target: "emhgmbd0",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "oldbq4",
  styles: "user-select:none"
} : {
  name: "oldbq4",
  styles: "user-select:none",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkluc3BlY3Rvci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMEM0QiIsImZpbGUiOiJJbnNwZWN0b3IudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IHVzZU1lbW8gfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IHVzZUVkaXRvciB9IGZyb20gJy4uLy4uL2hvb2tzL3VzZUVkaXRvcic7XG5pbXBvcnQgeyBmaW5kQW5jZXN0b3JOb2RlcywgZmluZE5vZGUsIHNldE5vZGUgfSBmcm9tICcuLi8uLi91dGlscy9ub2RlJztcblxuZXhwb3J0IGZ1bmN0aW9uIEluc3BlY3RvcigpOiBSZWFjdC5SZWFjdEVsZW1lbnQgfCBudWxsIHtcbiAgY29uc3QgeyBzdGF0ZSwgc2V0U3RhdGUsIGNvbXBvbmVudHMgfSA9IHVzZUVkaXRvcigpO1xuICBjb25zdCB7IGRvY3VtZW50LCBjdXJzb3IgfSA9IHN0YXRlO1xuICBjb25zdCBub2RlID0gZmluZE5vZGUoZG9jdW1lbnQsIGN1cnNvcik7XG4gIGNvbnN0IHBhcmVudHMgPSBmaW5kQW5jZXN0b3JOb2Rlcyhkb2N1bWVudCwgY3Vyc29yKS5tYXAoXG4gICAgKHsgY2hpbGRyZW4sIHByb3BzLCBwYXJlbnRzLCAuLi5vdGhlcnMgfSkgPT4gKHsgLi4ub3RoZXJzLCBwcm9wczoge30sIGNoaWxkcmVuOiBbXSB9KSxcbiAgKTtcblxuICBjb25zdCBjb21wb25lbnQgPSBub2RlICE9IG51bGwgPyBjb21wb25lbnRzW25vZGUudHlwZV0gOiBudWxsO1xuICBjb25zdCBjaGlsZCA9IHVzZU1lbW8oXG4gICAgKCkgPT4gY29tcG9uZW50ICE9IG51bGwgJiZcbiAgICAgIG5vZGUgIT0gbnVsbCAmJlxuICAgICAgY29tcG9uZW50LnJlbmRlckluc3BlY3RvciAhPSBudWxsICYmXG4gICAgICBjb21wb25lbnQucmVuZGVySW5zcGVjdG9yKHtcbiAgICAgICAgdmFsdWU6IHtcbiAgICAgICAgICBrZXk6IG5vZGUua2V5LFxuICAgICAgICAgIHR5cGU6IG5vZGUudHlwZSxcbiAgICAgICAgICBwYXJlbnRzLFxuICAgICAgICAgIHByb3BzOiB7IC4uLmNvbXBvbmVudD8uZGVmYXVsdFByb3BzLCAuLi5ub2RlLnByb3BzIH0sXG4gICAgICAgICAgY2hpbGRyZW46IG5vZGUuY2hpbGRyZW4sXG4gICAgICAgIH0sXG4gICAgICAgIG9uQ2hhbmdlOiAodmFsdWUpID0+IHtcbiAgICAgICAgICBzZXRTdGF0ZSgocHJldlN0YXRlKSA9PiAoe1xuICAgICAgICAgICAgLi4ucHJldlN0YXRlLFxuICAgICAgICAgICAgZG9jdW1lbnQ6IHNldE5vZGUocHJldlN0YXRlLmRvY3VtZW50LCBjdXJzb3IsIHZhbHVlKSxcbiAgICAgICAgICB9KSk7XG4gICAgICAgIH0sXG4gICAgICB9KSxcbiAgICBbY29tcG9uZW50LCBub2RlLCBjdXJzb3IsIHNldFN0YXRlXSxcbiAgKTtcbiAgaWYgKG5vZGUgPT0gbnVsbCkge1xuICAgIHJldHVybiBudWxsO1xuICB9XG4gIHJldHVybiA8Q29udGFpbmVyIGtleT17bm9kZS5rZXl9PnsgY2hpbGQgfTwvQ29udGFpbmVyPjtcbn1cblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgdXNlci1zZWxlY3Q6IG5vbmU7XG5gO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export { Inspector };
//# sourceMappingURL=Inspector.js.map
